export function LoadingIndicator() {
  return (
    <div role="status" aria-live="polite" className="app-loading">
      Loading…
    </div>
  );
}
